import { size } from 'lodash';

export default {
    buttons: {
        start: 'Start',
        end: 'End Activity',
        submit: 'Submit',
        next: 'Next Question',
        result: 'View Results',
        nextModule: 'Next',
        selfDone: 'Self-study Complete',
        moduleStart: 'Start Activity',
    },
    teacher: {
        setting: 'Activity Settings',
        wayOfProgress: 'Progression Method',
        wayOfReading: 'Reading Method',
        title: 'Activity Title',
        guide: 'Activity Guide',
        tooltip: `
        <span class="tooltip_list">
            <strong>With Teacher</strong>
            <span>Go through one question at a time with the Teacher</span>
         </span>
         <span class="tooltip_list">
            <strong>Self-paced</strong>
            <span>Students solve all questions at their own pace</span>
        </span>
        `,
        screen: 'Activity Screen',
        content: ({ values }: { values: { title?: string } }) => {
            const { title } = values;
            if (title) {
                return `Activity Content <span>${title}</span>`;
            }
            return 'Activity Content';
        },
        summary: 'Activity Summary',
    },
    alert: {
        wrong: "Oops, that's incorrect. Please try again.",
        waiting: () => {
            const messages = [
                'All done! Please wait a moment.',
                'Great! Please wait a moment.',
                'Good job! Please wait a moment.',
            ];
            return messages[Math.floor(Math.random() * size(messages))];
        },
    },
    question: 'Question',
    answerRate: 'Accuracy',
    relation: '{relation} Relationship',
    allDone: 'All questions have been completed. Please end the Activity!',
    champion: 'Champion',
    allSelect: 'Select All',
    majorVocabulary: 'Major Vocabulary',
    remainingVocabulary: 'Remaining Vocabulary',
    students: {
        errorTooltip: 'Student is offline',
        progress: {
            title: ({ values }: { values: { isOngoing: boolean } }) => {
                const { isOngoing } = values;
                return `Student ${isOngoing ? 'Status' : 'Results'}`;
            },
        },
        standby: 'Not Started',
        notAttended: 'Not Participated',
        inProgress: 'In Progress',
        notCompleted: 'Incomplete',
        completed: 'Completed',
    },
    modal: {
        title: 'End Activity',
        message: 'Would you like to end the Activity?',
    },
    state: {
        correct: 'Correct',
        wrong: 'Incorrect',
    },
};
